import { FC, useRef } from 'react'
import { Center, useRadio } from '@chakra-ui/react'
import { Box, Text } from '../index'
import { RadioButtonProps } from './interfaces'
import { RadioButton } from './radio-button'
import theme from '../../styles'
import { selectAnswers } from '../../state'
import { Steps } from '../../state/interfaces'
import { useSelector } from 'react-redux'

export const LargePillRadioButtonWithOptions: FC<RadioButtonProps> = (props) => {
  const { getInputProps, getCheckboxProps } = useRadio(props)
  const answers = useSelector(selectAnswers)
  const answerStep: string = answers[Steps.VALUE_THE_MOST_CHOICES_1] ? answers[Steps.VALUE_THE_MOST_CHOICES_1]![0] : ''
  const inputRef = useRef<HTMLInputElement>(null)

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  return (
    <Box
      as="label"
      cursor="pointer"
      data-testid={`pill-${props.value}`}
      display="flex"
      justifyContent="center"
      className={answerStep && (answerStep === props.value ? 'disabled' : '')}
      tabIndex={0}
      onFocus={handleFocus}
      _focus={{
        borderColor: 'brand',
        boxShadow: '0 0 0 2px #5bce4c',
      }}
    >
      <Center {...getCheckboxProps()} layerStyle={theme.LayerStyles.LARGE_PILL} aria-label={`button-${props.label}`}>
        <RadioButton {...getInputProps()} ref={inputRef} />
        <Text>{props.label}</Text>
      </Center>
    </Box>
  )
}
